export function loadDokbotLibrary(
  dokbotScriptUrl = 'https://resources.dokbot.io/bootstrap/bootstrap.min.js',
): void {
  if (typeof window === 'undefined' || typeof window.document === 'undefined') {
    return;
  }
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.defer = true;
  script.src = dokbotScriptUrl;
  document.body.append(script);
}
